import { batch } from 'react-redux';
import { getStore } from '../store'; // Import the store getter
import axios from '../../axiosInstance'
import AccountActionTypes from '../account/account.types';
import  AuthActionTypes  from './auth.types';
import UserActionTypes from '../user/user.types';
import { ACCESS_DENIED_MESSAGE, isAuthError, isBlockedIpError } from "../../utils/authErrors";

const loginUrl = `/v1/login`
const loginSecretUrl = `/v1/secret_login`
const loginTwoFactorVerifyUrl = `/v1/login/2fa/verify`
const logoutUrl = `/v1/logout`
const verifyAccountUrl = '/v1/verify_account'
const updateTncUrl = '/v1/update_tnc'
const resetPasswordUrl = '/v1/password/forgot'
const verifyResetPasswordUrl = '/v1/password/reset'
const accountActivationUrl = '/v1/create_password'
const checkaccountActivationUrl = '/v1/check_activation_link?email='
// const mockTwoFactorEmail = 'fake@petrocard.com'
// const mockLoginSuccessEmail = 'cliu@petrocard.com'

const handleLoginSuccess = (dispatch, payload) => {
  if (payload?.two_factor_required) {
    dispatch({
      type: AuthActionTypes.TWO_FACTOR_REQUIRED,
      payload
    })
    return {
      twoFactorRequired: true,
      data: payload
    }
  }

  dispatch({
    type: AuthActionTypes.LOGIN_SUCCESS,
    payload: payload.data
  })

  return {
    twoFactorRequired: false,
    data: payload.data
  }
}

export const login = (email, password) =>  {
  return async (dispatch) => {
    try {
      dispatch({
        type: AuthActionTypes.LOGIN
      })

      // if (email === mockTwoFactorEmail) {
      //   return handleLoginSuccess(dispatch, {
      //     two_factor_required: true,
      //     two_factor_challenge_id: 'mock-two-factor-challenge-id',
      //     masked_phone: '***-***-1234',
      //     expires_in: 300,
      //     message: 'Two-factor authentication code sent.'
      //   })
      // }
      //
      // if (email === mockLoginSuccessEmail) {
      //   return handleLoginSuccess(dispatch, {
      //     data: {
      //       object: 'User',
      //       id: 'mock-user-uuid',
      //       name: 'Mock PetroCard User',
      //       email,
      //       access_token: 'mock-jwt-access-token',
      //       token_type: 'Bearer',
      //       expires_in: 60,
      //       tnc: true,
      //       refresh_token: 'mock-jwt-refresh-token',
      //       status: 0
      //     }
      //   })
      // }

      const res = await axios.post(
        loginUrl,
        {
          email,
          password
        }
      )

      return handleLoginSuccess(dispatch, res.data)
    } catch (err) {
      const errorMessage = isBlockedIpError(err)
        ? ACCESS_DENIED_MESSAGE
        : err?.response?.data?.message

      dispatch({
        type: AuthActionTypes.LOGIN_FAILURE,
        payload: err && err.response && err.response.status,
        message: errorMessage
      })
      return err.response
    }
  }
}

export const loginSecret = (secret) =>  {
  return async (dispatch) => {
    try {
      dispatch({
        type: AuthActionTypes.LOGIN
      })

      const res = await axios.post(
        loginSecretUrl, secret
      )

      return handleLoginSuccess(dispatch, res.data)
    } catch (err) {
      const errorMessage = isBlockedIpError(err)
        ? ACCESS_DENIED_MESSAGE
        : err?.response?.data?.message

      dispatch({
        type: AuthActionTypes.LOGIN_FAILURE,
        payload: err && err.response && err.response.status,
        message: errorMessage
      })
      return err.response
    }
  }
}

export const verifyTwoFactorLogin = ({ challenge_id, token }) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: AuthActionTypes.VERIFY_TWO_FACTOR
      })

      const res = await axios.post(
        loginTwoFactorVerifyUrl,
        {
          challenge_id,
          token
        }
      )

      dispatch({
        type: AuthActionTypes.LOGIN_SUCCESS,
        payload: res.data.data
      })

      return res
    } catch (err) {
      const errorMessage = isBlockedIpError(err)
        ? ACCESS_DENIED_MESSAGE
        : err?.response?.data?.message

      dispatch({
        type: AuthActionTypes.VERIFY_TWO_FACTOR_FAILURE,
        payload: err && err.response && err.response.status,
        message: errorMessage
      })
      return err.response
    }
  }
}

export const clearTwoFactor = () => {
  return (dispatch) => {
    dispatch({
      type: AuthActionTypes.CLEAR_TWO_FACTOR
    })
  }
}



  
export const verifyAccount = (accountId) =>  {
  return async (dispatch, getState) => {

    const state = getState()
    const token = state.auth.token
    const userId = state.account.account.user_id
    const accounts = state.account.account.accounts
    const account = accounts.filter((item) => {
      return item.account_number === accountId;
    })

    try {
      dispatch({
        type: AuthActionTypes.VERIFY_ACCOUNT
      })

      const res = await axios.post(
        verifyAccountUrl,
        {
          user_id: userId
        },
        {
          headers: {
            Authorization: 'Bearer ' + token,
            AccountId: accountId
          }
        }
      )

      dispatch({
        type: AuthActionTypes.VERIFY_ACCOUNT_SUCCESS,
        payload: res.data.data
      })

    } catch (err) {
      if (isAuthError(err)) {
        dispatch(tokenExpired())
      }
      dispatch({
        type: AuthActionTypes.VERIFY_ACCOUNT_FAILURE
      })
    }
  }
}

export const verifyActivation = () => {
   return async (dispatch, getState) => {

    const state = getState()
    const token = state.auth.token
    const userId = state.auth.user.id

    try {
      dispatch({
        type: AuthActionTypes.VERIFY_ACTIVATION
      })

      const res = await axios.post(
        updateTncUrl,
        {
         is_terms_condition: true
        },
        {
          headers: {
            Authorization: 'Bearer ' + token,
            userId
          }
        }
      )

      dispatch({
        type: AuthActionTypes.VERIFY_ACTIVATION_SUCCESS,
        payload: res.data.data
      })

    } catch (err) {
      dispatch({
        type: AuthActionTypes.VERIFY_ACTIVATION_FAILURE
      })
    }
  }
}

export const logout = () =>  {
  return async (dispatch, getState) => {
    const state = getState()
    const token = state.auth.token
  
    try {
      dispatch({
        type: AuthActionTypes.LOGOUT
      })
  
      // await axios.delete(logoutUrl, {
      //   headers: {
      //     Authorization: 'Bearer ' + token
      //   }
      // })

      batch(() => {
        dispatch({
          type: AuthActionTypes.LOGOUT_SUCCESS
        });
        dispatch({
          type: AccountActionTypes.DEFAULT_ACCOUNT
        });
      });

    } catch (err) {
      dispatch({
        type: AuthActionTypes.LOGOUT_FAILURE
      })
    }
  }
}

export const accountActivation = ({email, token, password, password_confirmation}) => {
  return async (dispatch, getState) => {
   try {
     dispatch({
       type: AuthActionTypes.ACTIVATION_ACCOUNT
     })

     const res = await axios.post(
      accountActivationUrl,
      {
        email,
        token,
        password,
        password_confirmation
      }
    )

     dispatch({
       type: AuthActionTypes.ACTIVATION_ACCOUNT_SUCCESS,
       payload: res.status
     })

     return res.status;

   } catch (err) {
     dispatch({
       type: AuthActionTypes.ACTIVATION_ACCOUNT_FAILURE,
       payload: err.response.data.message
     })
     return err.response
   }
 }
}

export const checkAccountActivation = (email) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: AuthActionTypes.CHECK_ACTIVATION_ACCOUNT
      })
      const res = await axios.get(
        checkaccountActivationUrl + encodeURIComponent(email)
      )

      dispatch({
        type: AuthActionTypes.CHECK_ACTIVATION_ACCOUNT_SUCCESS
      })

      if(!res.data){
        dispatch({
          type: AuthActionTypes.CHECK_ACTIVATION_ACCOUNT_ACTIVATED
        })
      }

    } catch (err) {
      dispatch({
        type: AuthActionTypes.CHECK_ACTIVATION_ACCOUNT_FAILURE,
        payload: err.response.data.message
      })
    }
  }
}


export const activationAccountSetInitial = () => {
  return (dispatch, getState) => {
    dispatch({
      type: AuthActionTypes.ACTIVATION_ACCOUNT_SET_INITIAL,
    });
  };
};

export const verifyResetPassword = ({email, token, password, password_confirmation}) => {
  return async (dispatch, getState) => {

   try {
     dispatch({
       type: AuthActionTypes.VERIFY_RESET_PASSWORD
     })

     const res = await axios.post(
       verifyResetPasswordUrl,
       {
         email,
         token,
         password,
         password_confirmation
       }
     )

     dispatch({
       type: AuthActionTypes.VERIFY_RESET_PASSWORD_SUCCESS,
       payload: res.status
     })

     return res.status;

   } catch (err) {
     dispatch({
       type: AuthActionTypes.VERIFY_RESET_PASSWORD_FAILURE
     })
     return err.response
   }
 }
}

export const resetPassword = (email) => {
  return async (dispatch, getState) => {

   try {
     dispatch({
       type: AuthActionTypes.RESET_PASSWORD
     })

     const res = await axios.post(
       resetPasswordUrl,
       {
         email,
         reseturl: process.env.REACT_APP_BASE_URL + '/auth/reset-password'
       }
     )

     dispatch({
       type: AuthActionTypes.RESET_PASSWORD_SUCCESS,
       payload: res.data.data,
       email: email
     })

     return res

   } catch (err) {
     batch(() => {
      dispatch({
        type: AuthActionTypes.RESET_PASSWORD_FAILURE,
        payload: err.response.data.message
      })
      dispatch({
        type: UserActionTypes.OPEN_POPUP,
        payload: {
          email: '',
          status: AuthActionTypes.RESET_PASSWORD_FAILURE,
          error: true,
          showStatusText: false
        }
      })
     })

     return err.response
   }
 }
}

export const tokenExpired = () =>  {
  return async (dispatch, getState) => {
  
    dispatch(logout())
    .then(() => {
      dispatch({
        type: UserActionTypes.OPEN_POPUP,
        payload: {
          status: 'token_expired',
          error: true
        }
      })
    })
  }
}

export const logoutForAccessDenied = () => {
  return async (dispatch) => {
    await dispatch(logout())
    dispatch({
      type: UserActionTypes.OPEN_POPUP,
      payload: {
        status: 'access_denied',
        error: true,
        showStatusText: false
      }
    })
  }
}

const refreshToken = async () => {
  try {
    const state = getStore().getState();
    const newToken = state.auth.refreshToken; // Get the current token from Redux state
    const { dispatch } = getStore();
    if (newToken) {
      dispatch({
        type: AuthActionTypes.UPDATE_TOKEN,
        payload: newToken
      });
    }
    return newToken;
  } catch (err) {
    console.error('Failed to refresh token:', err);
    throw err;
  }
};

axios.interceptors.response.use(
    (response) => response, // If success, just return the response.
    async (error) => {
      const { dispatch } = getStore();
      const originalRequest = error.config;
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const newToken = await refreshToken();
          if (newToken) {
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            return axios(originalRequest);
          }
        } catch (err) {
          console.warn('Refresh token failed, logging out the user.');
          dispatch(logout());
          return Promise.reject(err);
        }

        dispatch(logout());
      }
      return Promise.reject(error);
    }
);
